import { createFileRoute } from '@tanstack/react-router';
import { CarriersOverview } from '@uturn/portal/modules/carriers/pages/overview';

export const Route = createFileRoute('/_protected/carriers/')({
	component: CarriersOverview,
});
